import { View } from "@react-pdf/renderer";
import { defaultTo } from "lodash";
import React from "react";
import { PDFStyleConfigs } from "../../configs";
import { useAnalysisPDFStyles } from "@hooks/useAnalysisPDFStyle";

export const PDFPageBody = ({
  children,
  isFirstPage,
  pageIndex,
  isReview,
  shouldRemoveHeading = defaultTo(pageIndex, 0) >
    PDFStyleConfigs.MaxPageIndexToShowMainHeader,
}: {
  children?: React.ReactNode;
  isFirstPage?: boolean;
  pageIndex?: number;
  shouldRemoveHeading?: boolean;
  isReview?: boolean;
}) => {
  const { pageStyle } = useAnalysisPDFStyles();

  return (
    <View
      style={
        isFirstPage
          ? {
              ...pageStyle.body,
              height: isReview
                ? PDFStyleConfigs.ReviewFirstPageBodyHeight
                : PDFStyleConfigs.FirstPageBodyHeight,
            }
          : {
              ...pageStyle.body,
              height: shouldRemoveHeading
                ? isReview
                  ? PDFStyleConfigs.ReviewPageBodyHeightWithoutHeading
                  : PDFStyleConfigs.PageBodyHeightWithoutHeading
                : isReview
                ? PDFStyleConfigs.ReviewPageBodyHeight
                : PDFStyleConfigs.PageBodyHeight,
            }
      }
    >
      {children}
    </View>
  );
};
